module.exports = __webpack_public_path__ + "img/bg-research.1b171f32.jpg";